// ----------------------------------------------------------------------------
// Section: Collapsible Content
// ----------------------------------------------------------------------------

import 'snippets/_containers/accordion/accordion';
import './_collapsible-content.scss';